import { getDefaultValue } from 'src/components/shared/form-elements';
import { FormInput, MortgageCertificateFormFields } from '../../../../../@types';
import { utilNumberToCurrency } from '../../../../../utils';

export const mortgageCertificateFormFields: Record<keyof MortgageCertificateFormFields, FormInput> =
  {
    // applicant
    appointmentDate: {
      fieldName: 'appointmentDate',
      label: 'Afspraak datum',
      type: 'date',
      defaultValue: getDefaultValue('2023-09-27')
    },
    firstname: {
      fieldName: 'firstname',
      label: 'Voornaam',
      type: 'text',
      defaultValue: getDefaultValue('firstname')
    },
    lastname: {
      fieldName: 'lastname',
      label: 'Achternaam',
      type: 'text',
      defaultValue: getDefaultValue('lastname')
    },
    partnerFirstname: {
      fieldName: 'partnerFirstname',
      label: 'Partner voornaam',
      type: 'text',
      defaultValue: getDefaultValue('partnerFirstname')
    },
    partnerLastname: {
      fieldName: 'partnerLastname',
      label: 'Partner achternaam',
      type: 'text',
      defaultValue: getDefaultValue('partnerLastname')
    },
    street: {
      fieldName: 'street',
      label: 'Straat',
      type: 'text',
      defaultValue: getDefaultValue('street')
    },
    houseNumber: {
      fieldName: 'houseNumber',
      label: 'Huisnummer',
      type: 'text',
      defaultValue: getDefaultValue('123AB')
    },
    postcode: {
      fieldName: 'postcode',
      label: 'Postcode',
      type: 'text',
      defaultValue: getDefaultValue('1034 BA')
    },
    city: {
      fieldName: 'city',
      label: 'Plaatsnaam',
      type: 'text',
      defaultValue: getDefaultValue('city')
    },
    phoneNumber: {
      fieldName: 'phoneNumber',
      label: 'Telefoonnummer',
      type: 'text',
      defaultValue: getDefaultValue('0624237484')
    },
    // mortgage
    interestRate: {
      fieldName: 'interestRate',
      label: 'Rente',
      type: 'percentage',
      defaultValue: getDefaultValue('1.5%')
    },
    nhg: {
      fieldName: 'nhg',
      label: 'NHG',
      type: 'radio',
      options: [
        { label: 'Ja', value: 'true' },
        { label: 'Nee', value: 'false' }
      ],
      defaultValue: getDefaultValue('true')
    },
    mortgageAmount: {
      fieldName: 'mortgageAmount',
      label: 'Hypotheekbedrag',
      type: 'currency',
      defaultValue: getDefaultValue(utilNumberToCurrency(450000, true))
    },
    mortgageYears: {
      fieldName: 'mortgageYears',
      label: 'Rentevaste periode in jaren',
      type: 'number',
      defaultValue: getDefaultValue('30')
    },
    ownResources: {
      fieldName: 'ownResources',
      label: 'Eigen middelen/Overbruggingshypotheek',
      type: 'currency',
      defaultValue: getDefaultValue(utilNumberToCurrency(20000, true))
    },
    newHouseStreet: {
      fieldName: 'newHouseStreet',
      label: 'Straat nieuwe woning',
      type: 'text',
      defaultValue: getDefaultValue('newHouseStreet')
    },
    newHouseHouseNumber: {
      fieldName: 'newHouseHouseNumber',
      label: 'Huisnummer nieuwe woning',
      type: 'text',
      defaultValue: getDefaultValue('newHouseHouseNumber')
    },
    newHousePostcode: {
      fieldName: 'newHousePostcode',
      label: 'Postcode nieuwe woning',
      type: 'text',
      defaultValue: getDefaultValue('1035 BA')
    },
    newHouseCity: {
      fieldName: 'newHouseCity',
      label: 'Plaatsnaam nieuwe woning',
      type: 'text',
      defaultValue: getDefaultValue('newHouseCity')
    },
    newHouseEnergyLabel: {
      fieldName: 'newHouseEnergyLabel',
      label: 'Energielabel',
      type: 'select',
      options: [
        { value: 'A++++ incl. EGP', label: 'A++++ incl. energieprestatiegarantie' },
        { value: 'A++++', label: 'A++++' },
        { value: 'A+++', label: 'A+++' },
        { value: 'A++', label: 'A++' },
        { value: 'A+', label: 'A+' },
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: 'Geen label', label: 'Geen label' },
        { value: '', label: 'Selecteer een energielabel' }
      ],
      defaultValue: getDefaultValue('A++++ incl. EGP')
    },
    // office - hidden, office search
    officeId: {
      fieldName: 'officeId',
      label: 'Vestiging',
      type: 'select',
      placeHolder: 'Selecteer een vestiging',
      defaultValue: getDefaultValue('1349')
    },
    /*officeStreet: {
      fieldName: 'officeStreet',
      label: '',
      type: 'text',
      defaultValue: getDefaultValue('officeStreet')
    },
    officeHouseNumber: {
      fieldName: 'officeHouseNumber',
      label: '',
      type: 'text',
      defaultValue: getDefaultValue('officeHouseNumber')
    },
    officePhoneNumber: {
      fieldName: 'officePhoneNumber',
      label: '',
      type: 'text',
      defaultValue: getDefaultValue('officePhoneNumber')
    },
    officePostcode: {
      fieldName: 'officePostcode',
      label: '',
      type: 'text',
      defaultValue: getDefaultValue('officePostcode')
    },
    officeCity: {
      fieldName: 'officeCity',
      label: '',
      type: 'text',
      defaultValue: getDefaultValue('officeCity')
    },*/
    // extra
    issueDate: {
      fieldName: 'issueDate',
      label: 'Uitgifte datum',
      type: 'date',
      defaultValue: getDefaultValue('2010-09-27')
    },
    consultantName: {
      fieldName: 'consultantName',
      label: 'Naam adviseur',
      type: 'text',
      defaultValue: getDefaultValue('consultantName')
    }
  };
